import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Tooltip, notification, Modal, Skeleton, Button as AntButton } from 'antd';
import { Context, State, useSave, useFetch, Request, useGet } from 'store';
import QRCode from 'qrcode.react';
import moment from 'moment';
import 'moment-timezone';
import services from '_src/services';
import { Select } from '_src/shared/form-helpers';
import { PersistentRepo } from '_src/shared/repo';
import { Button } from '_src/ui';
import { Restricted } from '_src/shared/restrict';
import StudentTimeline from '_src/modules/Students/components/Timeline/StudentTimeline';
import { Refresh } from '_src/components';
import StyledButton from '../../ui/Button/styles';
import holidayIcon from '_src/assets/images/palm-tree.png';
import {
  Absent,
  Override,
  StudentPerformanceEvaluator,
  WarningLabel,
  StudentIntervention
} from './components';

import {
  TwoColumns,
  PageContainer,
  PageTitle,
  CenterCol,
  TableContainer,
  THeader,
  FirstCol,
  MiddleCol,
  ThirdCol,
  TRow,
  Name,
  AttendanceValue,
  GridImage,
  TitleRow,
  Row,
  CardBlock,
  Totals,
  LabelCard,
  StudentRow,
  StudentContainer,
  AttendanceIcons,
  ClockIcon,
  SuccessfulSubmissionsIcon,
  CenterText,
  StudentIcons,
  ButtonContainer,
  AttendanceContainer,
  LastSessionDate,
  AttendanceStatusImage,
  StyledTooltip,
  AttendanceTooltipStyles,
  TooltipTitle,
  TooltipRow,
  EmptyPlaceholderText
} from './styles';
import greenMan from '_src/assets/images/green-man-user.png';
import redMan from '_src/assets/images/red-man-user.png';
import orangeMan from '_src/assets/images/man-user.png';
import checked from '_src/assets/images/checked.png';
import absentImg from '_src/assets/images/absent.png';
import sessionClosed from '_src/assets/images/sessionClosed.png';
import doubleCheck from '_src/assets/images/double-checked.png';
import clock from '_src/assets/images/clock.png';
import theorySubmitted from '_src/assets/images/theory-submitted.png';
import rangeSubmitted from '_src/assets/images/range-submitted.png';

const buttonColor = GLOBALS.colors;

const testingConfig = [
  { id: 1, label: 'PRE TRIP' },
  { id: 3, label: 'SKILLS' },
  { id: 2, label: 'ROAD' },
  { id: 4, label: 'CHARACTER', showForBranch: true }
];

const locationFiltersConfig = [
  { id: 0, label: 'Both' },
  { id: 1, label: 'Yard' },
  { id: 2, label: 'Classroom' }
];

var timezoneParam = moment().utcOffset() / 60;

if (timezoneParam > 0) {
  timezoneParam = 'GMT ' + timezoneParam;
} else if (timezoneParam < 0) {
  timezoneParam = 'GMT' + timezoneParam;
} else if (timezoneParam === 0) {
  timezoneParam = 'GMT 0';
}

const getBranchTimezone = PersistentRepo.get('getTimezone');
const fmt = 'MM/DD/YYYY HH:mm';

const performanceToColor = {
  UNSUCCESFUL: buttonColor.RED,
  'NEEDS IMPROVEMENT': buttonColor.ORANGE,
  SATISFACTORY: buttonColor.YELLOW,
  PROFICIENT: buttonColor.GREEN
};

export default () => {
  const resource = 'attendance';
  const config = services[resource];
  const autoArchiveConfig = services['autoArchive'];
  const { setShown, getShown, refreshResource, getData, setData } = useContext(Context);
  const getInitialLocation = () => {
    const location = PersistentRepo.get('location');
    const user = getData('user');
    const branchId = user.branchId || 1;

    let selectedFilterLocation = 0;
    if (location) {
      const type = location?.split('x')[0];
      if (type === 'classroom') {
        selectedFilterLocation = 2;
      }
      if (type === 'yard') {
        selectedFilterLocation = 1;
      }
    }

    const selectedBranch = location ? location : `allxallx${branchId}`;
    return { selectedBranch, selectedFilterLocation };
  };
  const { selectedBranch, selectedFilterLocation } = getInitialLocation();

  const [getTimezone, setTimezone] = useState();
  const [location, setLocation] = useState(selectedBranch);
  const [locationFilter, setLocationFilter] = useState(selectedFilterLocation);

  const [classType, setClassType] = useState(
    PersistentRepo.get('day') ? PersistentRepo.get('day') : ['all']
  );
  const [userName, setUserName] = useState('');
  const [showOpenSessionDates, setShowOpenSessionDates] = useState(false);
  const [showUnfilledHBDDates, setShowUnfilledHBDDates] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState();
  const [testingType, setTestingType] = useState(-1);
  const [openSessionsList, setOpenSessionsList] = useState([]);
  const [unfilledHBDList, setUnfilledHBDList] = useState([]);
  const [selectedDateSession, setSelectedDateSession] = useState();
  const [unsignedUser, setUnsignedUser] = useState();
  const [selectedGroup, setGroup] = useState('all');
  const [rerender, setRenender] = useState(Date.now());
  const [attendanceData, setAttendanceData] = useState([]);
  const [studentPerformance, setStudentPerformance] = useState([]);
  const [studentEvaluationNumber, setStudentEvaluationNumber] = useState({});

  const [totalInstructors, setTotalInstructors] = useState(0);

  const { save: create } = useSave(config.create);
  const { save: edit } = useSave(config.edit);
  const { get: openSessions } = useFetch(config.getOpenSessions);
  const { get: unfilledHBD } = useFetch(config.getUnfilledHBD);
  const { get: getTotalInstructors } = useFetch(config.getTotalInstructors);

  const { save: getStudentsPerformance, busy: studentsPerformanceBusy } = useSave(
    config.getStudentsPerformance
  );

  const { save: getStudentsEvaluationNumber, busy: getStudentsEvaluationNumberBust } = useSave(
    config.getStudentsEvaluationNumber
  );

  const { data: autoArchiveStudents, busy: autoArchiveBusy } = useGet({
    ...autoArchiveConfig.get,
    params: { branchId: mainBranchId }
  });

  const filteredAutoArchiveStudents = (autoArchiveStudents || []).filter(
    ({ archiveCp, dismissed }) => !Boolean(archiveCp) && !Boolean(dismissed)
  );

  const { save: getStudentsProficiency, busy: studentsProficiencyBusy } = useSave(
    config.getStudentsProficiency
  );

  const hasSelectedLocation = !!location;

  const instructorReportsConfig = services['instructorReports'];
  const [sponsors, setSponsor] = useState(['all']);
  const [studentStatus, setStudentStatus] = useState(
    PersistentRepo.get('studentStatus') ? PersistentRepo.get('studentStatus') : ['Active']
  );

  const history = useHistory();
  const handleBulkAttendanceClick = () => history.push('/bulkAttendance');

  const [mainLocationType, mainLocationId, mainBranchId] = (location || '')?.split('x');
  const allLocations = getData('locations');

  useEffect(() => {
    if (allLocations && location) {
      let timezone = allLocations
        ? allLocations.find(({ id }) => id === location)
          ? allLocations.find(({ id }) => id === location).timezone
          : ''
        : '';
      const openingHr = allLocations
        ? allLocations.find(({ id }) => id === location)
          ? allLocations.find(({ id }) => id === location).openingHour
          : ''
        : '';

      setTimezone(timezone);
      PersistentRepo.set('getTimezone', getTimezone);
      PersistentRepo.set('openingHour', openingHr);

      if (!allLocations.find(({ id }) => id === location)) {
        onFilterBranch(allLocations[0]?.id);
      }
    }

    const { firstName = '' } = PersistentRepo.get('user', {});
    setUserName(firstName);
  });

  let count = 0;
  useEffect(() => {
    if (attendanceData.length) {
      count++;
    }
    if (count === 1) {
      getStudentsPerformance({
        students: attendanceData.map(e => e.id),
        branchId: mainBranchId
      }).then(res => {
        setStudentPerformance(res.data.performance);
      });

      getStudentsEvaluationNumber({
        students: attendanceData.map(e => e.id)
      }).then(res => setStudentEvaluationNumber(res.data.evaluationsCounts));
    }
  }, [attendanceData]);

  useEffect(() => {
    if (!mainBranchId) return;

    getTotalInstructors({ replace: { branchId: mainBranchId } }).then(res => {
      setTotalInstructors(res);
    });
  }, [mainBranchId]);

  const formatLatestResult = (latestResult, type, showEvaluationNumber) => {
    if (latestResult === null || latestResult === undefined || latestResult === '') {
      return '-';
    }

    const numericType = Number(type);

    if (numericType === 1) {
      const value = Number(String(latestResult).split('%')[0]);
      return `${Math.round(value)}% Performance`;
    }

    if (numericType === 0) {
      return `${Math.round(Number(latestResult) * 100)}% Completed`;
    }

    if (showEvaluationNumber) {
      const label = Number(latestResult) === 1 ? 'Evaluation' : 'Evaluations';
      return `${latestResult} ${label}`;
    } else {
      return '';
    }
  };

  const locationFilterOptions = useMemo(() => {
    const branchLocations = (allLocations || []).filter(
      l => `${l.branchId}` === location?.split('x')[2]
    );
    const branchTypes = branchLocations.map(l => l.type);
    return locationFiltersConfig.map(l => ({ ...l, disabled: !branchTypes.includes(l.id) }));
  }, [location, allLocations]);

  const onFilterBranch = (loc, resetLocationFilter) => {
    const openingHr = allLocations
      ? allLocations.find(({ id }) => id === location)
        ? allLocations.find(({ id }) => id === location).openingHour
        : ''
      : '';
    setLocation(loc);
    PersistentRepo.set('openingHour', openingHr);
    resetLocationFilter && setLocationFilter(0);
    PersistentRepo.set('location', loc);
    PersistentRepo.get('allBranches') && PersistentRepo.delete('allBranches');
  };

  const onFilterByLocation = val => {
    setLocationFilter(val);
    const selectedLocation = allLocations.find(
      l => `${l.branchId}` === location.split('x')[2] && l.type === val
    ).id;
    onFilterBranch(selectedLocation, false);
  };

  const saveAbsentStudents = (absent = []) => {
    const [locationType, locationId, branchId] = location.split('x');
    const allStudents = getData('attendance').reduce(
      (acc, { id, locationType }) => ({ ...acc, [id]: locationType }),
      {}
    );

    const requests = absent.map(({ id, isExcused, attendanceId }) => {
      let utcTimeNow = moment.parseZone(moment()).format(fmt);
      let data = {
        locationId,
        locationType: locationType === 'yard' ? 1 : 2,
        branchId,
        attendanceDate: moment.tz(utcTimeNow, fmt, getBranchTimezone).unix(),
        excusedAbsence: isExcused
      };

      if (locationType === 'all') {
        const studentLocationType = allStudents[id];
        const studentLocationId = allLocations.find(loc => loc.branchId == branchId).branchLocation[
          studentLocationType === 1 ? 'yardId' : 'classroomId'
        ];

        data.locationId = studentLocationId;
        data.locationType = studentLocationType;
      }

      if (attendanceId) {
        return edit({ excusedAbsence: isExcused, id: attendanceId });
      } else {
        return create({ ...data, studentId: id });
      }
    });

    Promise.all(requests).then(responses => {
      if (responses.length && responses.every(resp => resp.success === 1)) {
        refreshResource(resource);
        notification.success({
          message: `Successfully marked as absent`,
          duration: 5
        });
      }
    });
  };

  const updateModal = item => {
    if (openSessionsList.length > 0) {
      const _index = openSessionsList.findIndex(session => {
        return moment(session.attendanceDate).format('MM/DD/YYYY') === item.format('MM/DD/YYYY');
      });

      if (showOpenSessionDates && _index > -1) {
        openSessionsList.splice(_index, 1);
        if (openSessionsList.length === 0) {
          setShowOpenSessionDates(false);
        }
      }
    }
  };

  const renderAttendance = () => {
    const [locationType, locationId, branchId] = location.split('x');
    const date = moment().format('DD-MM-YYYY');
    let daysFilter = classType
      .filter(day => day !== 'all')
      .reduce((acc, curr) => ((acc[curr] = 1), acc), {});

    if (daysFilter.dayClass) {
      delete daysFilter.dayClass;
      daysFilter.nightClass = false;
    }

    const sponsorsFilter = sponsors.filter(sponsor => sponsor !== 'all');
    let attendanceParams = {
      date,
      timezone: timezoneParam,
      locationType: 0,
      locationId: branchId,
      ...(sponsorsFilter.length && { sponsors: sponsorsFilter.join(',') }),
      ...(studentStatus.length &&
        studentStatus[0] !== 'all' && { status: studentStatus.join(',') }),
      ...daysFilter,
      rerender,
      ...(selectedGroup && selectedGroup != 'all' && { groups: selectedGroup }),
      ...(studentStatus.includes('Waiting for start date') && { awaitingYardStartDate: true })
    };
    let reportParams = { branchId, date };
    if (locationType !== 'all') {
      attendanceParams.locationType = locationType === 'yard' ? 1 : 2;
      attendanceParams.locationId = locationId;
    }

    return (
      <>
        <Request.Get {...config.get} params={[attendanceParams, attendanceParams]}>
          {({ data, busy }) => (busy ? renderBusyForm() : renderTable(data))}
        </Request.Get>
        {renderTakeAttendance()}
      </>
    );
  };

  const renderTakeAttendance = () => (
    <Restricted resource="attendance" method={['POST', 'PATCH']}>
      <State name="attendance">
        {students => {
          let [locationType] = location.split('x');

          if (locationType !== 'all') {
            locationType = locationType === 'yard' ? 1 : 2;
            students = students.filter(student => student?.locationType === locationType);
          }

          const rawStudent = students.find(({ id }) => selectedStudent === id) || {};
          const student = {
            ...rawStudent,
            isAutoArchive: Boolean(
              (filteredAutoArchiveStudents || []).find(({ id }) => id === rawStudent.id)?.id
            ),
            autoArchiveStudents: autoArchiveStudents
          };

          return (
            <>
              {getShown('testing') && (
                <Restricted resource="testing/responses" method={['POST', 'PATCH']}>
                  <StudentPerformanceEvaluator
                    resource="testing"
                    type={testingType}
                    student={student}
                  />
                </Restricted>
              )}

              {getShown('absence') && <Absent save={saveAbsentStudents} students={students} />}

              {getShown('override') && (
                <Override
                  locationType={locationType}
                  student={student}
                  selectedDateSession={selectedDateSession}
                  onModalClose={updateModal}
                />
              )}

              {getShown('studentTimeline') && (
                <StudentTimeline rerenderEvaluations={() => setRenender(Date.now())} />
              )}
            </>
          );
        }}
      </State>
    </Restricted>
  );

  const renderBusyForm = () => (
    <TableContainer>
      <Skeleton active title={false} paragraph={{ rows: 15 }} />
    </TableContainer>
  );

  const openUnclosedSessions = ({ id }) => {
    openSessions({
      replace: { id }
    }).then(response => {
      const res = response[0];
      if (res.success === 1) {
        res.data.openSessionsDates.sort((a, b) => {
          const aAttendanceDate = moment(a.attendanceDate);
          const bAttendanceDate = moment(b.attendanceDate);
          return aAttendanceDate.isBefore(bAttendanceDate) ? 1 : -1;
        });

        setOpenSessionsList(res.data.openSessionsDates);
        setShowOpenSessionDates(true);
        setSelectedStudent(id);
      }
    });
  };

  const openUnfilledHBD = ({ id }) => {
    unfilledHBD({
      replace: { id }
    }).then(response => {
      const res = response[0];
      if (res.success === 1) {
        res.data.students.sort((a, b) => {
          const aHoursBreakdownDate = moment(a.hoursBreakdownDate);
          const bHoursBreakdownDate = moment(b.hoursBreakdownDate);
          return aHoursBreakdownDate.isBefore(bHoursBreakdownDate) ? 1 : -1;
        });

        setUnfilledHBDList(res.data.students);
        setShowUnfilledHBDDates(true);
        setSelectedStudent(id);
      }
    });
  };

  const renderName = record => {
    const {
      id,
      branchId,
      name,
      numberOfOpenSessions,
      unfilledHoursBreakdownDate,
      unfilledHoursBreakdownCount,
      isPublicHoliday,
      locationType,
      classSubmittedToFmsca,
      awaitingYardStartDate,
      yardSubmittedToFmsca,
      status
    } = record;

    const isAutoArchive = Boolean(
      (filteredAutoArchiveStudents || []).find(item => item.id === id)?.id
    );

    const parsedDate = moment(unfilledHoursBreakdownDate).parseZone();
    const parsedNow = moment().utc();
    const manIcon =
      unfilledHoursBreakdownDate && parsedNow.isSame(parsedDate, 'day') ? redMan : greenMan;
    const showClockIcon =
      (parsedNow.isSame(parsedDate, 'day') && unfilledHoursBreakdownCount > 1) ||
      !parsedNow.isSame(parsedDate, 'day');

    const tooltipLabel =
      awaitingYardStartDate && locationType === 1
        ? 'Awaiting Yard Start Date'
        : status === 'Hold'
        ? 'Student has Hold status'
        : status === 'Waiting for start date'
        ? 'Waiting for start date'
        : isAutoArchive
        ? 'Student has new program, contact regional'
        : '';
    return (
      <>
        <Tooltip
          title={
            unfilledHoursBreakdownDate && parsedNow.isSame(parsedDate, 'day')
              ? "This student has unfilled hours-breakdown for today's attendance"
              : ''
          }
        >
          <GridImage src={manIcon} w={16} h={21} />
        </Tooltip>

        <Tooltip title={tooltipLabel}>
          <Name
            onClick={() => {
              const branchName = allLocations
                ? allLocations.find(loc => branchId === loc.branchId).label.split(' ')[0]
                : '';

              const studentBranch = allLocations
                ? allLocations.find(loc => branchId === loc.branchId).branchId
                : '';

              setData('studentTimeline', {
                ...record,
                branchId: branchName,
                studentBranch: studentBranch,
                id,
                showOnlyBasicData:
                  (awaitingYardStartDate && locationType === 1) ||
                  isAutoArchive ||
                  status === 'Hold',
                isAutoArchive: isAutoArchive,
                autoArchiveStudents
              });
              setShown('studentTimeline');
            }}
            style={{
              opacity:
                (awaitingYardStartDate && locationType === 1) || isAutoArchive || status === 'Hold'
                  ? 0.5
                  : 1
            }}
          >
            {name}
          </Name>
        </Tooltip>

        <StudentIcons>
          {classSubmittedToFmsca && (
            <Tooltip title="Theory Submitted">
              <SuccessfulSubmissionsIcon src={theorySubmitted} />
            </Tooltip>
          )}
          {yardSubmittedToFmsca && (
            <Tooltip title="Road/Range Submitted">
              <SuccessfulSubmissionsIcon src={rangeSubmitted} />
            </Tooltip>
          )}
          {showClockIcon && (
            <Tooltip title="This student has unfilled hours-breakdown. Click here to assign all unassigned hours">
              <ClockIcon
                src={clock}
                onClick={() => {
                  if (
                    !isAutoArchive &&
                    !(awaitingYardStartDate && locationType === 1) &&
                    status !== 'Hold'
                  ) {
                    openUnfilledHBD(record);
                  }
                }}
              />
            </Tooltip>
          )}
          {numberOfOpenSessions > 0 && (
            <Tooltip title="This student has open sessions. Click here to close all the open sessions">
              <AttendanceIcons
                src={sessionClosed}
                onClick={() => {
                  if (
                    !isAutoArchive &&
                    !(awaitingYardStartDate && locationType === 1) &&
                    status !== 'Hold'
                  ) {
                    openUnclosedSessions(record);
                  }
                }}
              />
            </Tooltip>
          )}
          {isPublicHoliday && locationType === 1 && !classSubmittedToFmsca && (
            <Tooltip title="This student is submitted for public holiday.">
              <AttendanceIcons src={holidayIcon} />
            </Tooltip>
          )}
        </StudentIcons>
      </>
    );
  };

  const renderTable = data => {
    setAttendanceData(data);

    const totalCheckin = data.filter(
      item => item.attendanceStatus !== 'No attendance' && item.attendanceStatus !== 'Absent'
    ).length;
    const totalAbsent = data.filter(item => item.attendanceStatus === 'Absent').length;

    const otherBranchesCount = data.filter(({ branchId, originBranchId }) => {
      return originBranchId ? branchId !== originBranchId : branchId !== Number(mainBranchId);
    }).length;

    const currentBranchesCount = data.filter(({ branchId, originBranchId }) => {
      return originBranchId ? branchId === originBranchId : branchId === Number(mainBranchId);
    }).length;

    const automaticGearCount = data.filter(s => s.automaticGear === true).length;
    const manualGearCount = data.filter(s => s.automaticGear === false).length;

    const studentsTooltipRows = [
      {
        label: 'Original Branch',
        value: currentBranchesCount
      },
      {
        label: 'Transferred',
        value: otherBranchesCount
      },
      {
        label: 'Automatic',
        value: automaticGearCount
      },
      {
        label: 'Manual',
        value: manualGearCount
      }
    ];

    const rowsToRender =
      mainLocationType === 'classroom' ? studentsTooltipRows.slice(2) : studentsTooltipRows;

    const tooltipTitle = (
      <TooltipTitle>
        {rowsToRender.map(({ label, value }) => (
          <TooltipRow key={label}>
            <span>{label}:</span>
            <strong>{value}</strong>
          </TooltipRow>
        ))}
      </TooltipTitle>
    );

    const AttendanceStatus = ({ item }) => {
      if (item.attendanceStatus === 'Absent') {
        return (
          <Tooltip title={item.absent.isExcused ? 'Absent Excused' : 'Absent Unexcused'}>
            <AttendanceStatusImage src={absentImg} w={18} h={14} />
          </Tooltip>
        );
      }

      if (item.hasAttended) {
        return (
          <Tooltip
            title={
              item.attendance.checkIn ? 'This student is checked-in' : 'This student is checked-out'
            }
          >
            <AttendanceStatusImage
              src={item.attendance.checkIn ? checked : doubleCheck}
              h={item.attendance.checkIn ? 20 : 21}
            />
          </Tooltip>
        );
      }

      return (
        <div style={{ visibility: 'hidden' }}>
          <AttendanceStatusImage src={absentImg} w={18} h={14} />
        </div>
      );
    };

    return (
      <>
        <AttendanceTooltipStyles />
        {location.includes('classroom') && <WarningLabel />}

        <Row>
          <CardBlock>
            <LabelCard>Total Yard Instructors</LabelCard>
            <Totals>{totalInstructors}</Totals>
          </CardBlock>

          <CardBlock>
            <StyledTooltip title={tooltipTitle} placement="right" open={true}>
              <LabelCard>Total Students</LabelCard>
              <Totals>{data.length}</Totals>
            </StyledTooltip>
          </CardBlock>

          <CardBlock>
            <LabelCard>Total Checked In</LabelCard>
            <Totals>{totalCheckin}</Totals>
          </CardBlock>

          <CardBlock>
            <LabelCard>Total Absent</LabelCard>
            <Totals>{totalAbsent}</Totals>
          </CardBlock>
        </Row>

        <TableContainer>
          <THeader>
            <FirstCol>Students</FirstCol>
            <MiddleCol>Attendance</MiddleCol>
            <ThirdCol borderBottom={false}>Daily Evaluations</ThirdCol>
          </THeader>

          {data.map(item => (
            <TRow key={item.id}>
              <FirstCol>{renderName(item)}</FirstCol>

              <MiddleCol>
                <AttendanceContainer>
                  <span
                    aria-label={item.automaticGear ? 'Automatic (A)' : 'Manual (M)'}
                    style={{ textAlign: 'center', width: 20 }}
                  >
                    {item.automaticGear ? 'A' : 'M'}
                  </span>
                  <AttendanceValue
                    onClick={() => {
                      setSelectedStudent(item.id);
                      setSelectedDateSession(moment());
                      setShown('override');
                    }}
                  >
                    {item.totalHoursTrained}/{item.programHours}
                  </AttendanceValue>

                  <AttendanceStatus item={item} />
                </AttendanceContainer>

                <LastSessionDate>
                  {item.lastAttendance
                    ? moment(item.lastAttendance).parseZone().format('MM/DD/YYYY HH:mm')
                    : ''}
                </LastSessionDate>
              </MiddleCol>
              <ThirdCol borderBottom={true}>
                <Skeleton
                  loading={studentsPerformanceBusy || studentsProficiencyBusy}
                  paragraph={{ rows: 2 }}
                >
                  {!!studentPerformance &&
                    !!studentPerformance[item.id] &&
                    testingConfig.map(({ id, label, showForBranch }) => {
                      const isAutoArchive = Boolean(
                        (filteredAutoArchiveStudents || []).find(
                          autoArchivedStudent => autoArchivedStudent.id === item.id
                        )?.id
                      );

                      const disableBubble =
                        (item?.locationType === 2 && !showForBranch) ||
                        (item.awaitingYardStartDate && item.locationType === 1) ||
                        item.status === 'Hold' ||
                        isAutoArchive;

                      return (
                        <ButtonContainer key={id}>
                          <div style={{ marginBottom: '5px' }}>{label}</div>

                          <Tooltip
                            title={
                              studentPerformance[item.id][id]
                                ? studentPerformance[item.id][id].currPerformance
                                : ''
                            }
                          >
                            <StyledButton
                              key={id}
                              filled={true}
                              onClick={() => {
                                if (!(item?.locationType === 2 && !showForBranch)) {
                                  setSelectedStudent(item.id);
                                  setTestingType(id);
                                  setShown('testing');
                                }
                              }}
                              color={
                                studentPerformance[item.id][id]
                                  ? performanceToColor[
                                      studentPerformance[item.id][id].currPerformance
                                    ]
                                  : '#c1c1c1'
                              }
                              text={label}
                              height={55}
                              width={155}
                              disabled={disableBubble}
                              style={{
                                flexDirection: 'column',
                                opacity:
                                  (item.awaitingYardStartDate && item.locationType === 1) ||
                                  isAutoArchive ||
                                  item.status === 'Hold'
                                    ? 0.5
                                    : 1
                              }}
                            >
                              <span>
                                {studentPerformance[item.id][id]
                                  ? formatLatestResult(
                                      studentPerformance[item.id].testPercentages[id],
                                      0
                                    )
                                  : ''}
                              </span>

                              <span>
                                {studentPerformance[item.id][id]
                                  ? formatLatestResult(
                                      studentPerformance[item.id][id]?.lastestResult,
                                      1
                                    )
                                  : ''}
                              </span>
                            </StyledButton>
                          </Tooltip>
                          <span style={{ marginTop: '10px', height: '15px' }}>
                            {formatLatestResult(
                              studentEvaluationNumber[item.id]?.[id],
                              2,
                              !disableBubble ||
                                (disableBubble && studentEvaluationNumber[item.id]?.[id])
                            )}
                          </span>
                        </ButtonContainer>
                      );
                    })}
                </Skeleton>
              </ThirdCol>
            </TRow>
          ))}

          {data.length === 0 && locationFilter === 1 && (
            <EmptyPlaceholderText>No students available.</EmptyPlaceholderText>
          )}
        </TableContainer>
      </>
    );
  };

  const renderTablePlaceholder = () => <div>Please select a location</div>;

  const buttons = () => (
    <>
      <Button
        filled={false}
        color={buttonColor.ORANGE}
        text="Bulk Attendance"
        height={30}
        width={130}
        disabled={!hasSelectedLocation}
        onClick={handleBulkAttendanceClick}
        alignSelf="end"
      />
    </>
  );

  return (
    <PageContainer>
      <Refresh />

      <Modal
        title="List of open sessions"
        visible={showOpenSessionDates}
        footer={[
          <AntButton key="close" type="ghost" onClick={() => setShowOpenSessionDates(false)}>
            Close
          </AntButton>
        ]}
      >
        <span> This student has open sessions on these dates: </span>
        <StudentContainer>
          {openSessionsList.map(({ attendanceDate }, _index) => {
            const formatedSessionDate = moment(attendanceDate).parseZone();

            return (
              <StudentRow
                key={_index}
                onClick={() => {
                  setSelectedDateSession(formatedSessionDate);
                  setShown('override');
                }}
              >
                <div>{formatedSessionDate.format('MM/DD/YYYY')}</div>
              </StudentRow>
            );
          })}
        </StudentContainer>
      </Modal>

      <Modal
        title="List of unfilled hours breakdown"
        visible={showUnfilledHBDDates}
        footer={[
          <AntButton key="close" type="ghost" onClick={() => setShowUnfilledHBDDates(false)}>
            Close
          </AntButton>
        ]}
      >
        <span> This student has unfilled hours breakdown on these dates: </span>
        <StudentContainer>
          {unfilledHBDList.map(({ hoursBreakdownDate }, _index) => {
            const formatedHBDDate = moment(hoursBreakdownDate).parseZone();

            return (
              <StudentRow
                key={_index}
                onClick={() => {
                  setShowUnfilledHBDDates(false);
                  setSelectedDateSession(formatedHBDDate);
                  setShown('override');
                  setShown('checkoutModal');
                }}
              >
                <div>{formatedHBDDate.format('MM/DD/YYYY')}</div>
              </StudentRow>
            );
          })}
        </StudentContainer>
      </Modal>

      <Modal
        title="Scan the code to sign"
        visible={unsignedUser}
        footer={[
          <AntButton key="close" type="ghost" onClick={() => setUnsignedUser(false)}>
            Close
          </AntButton>
        ]}
      >
        <CenterText>
          <QRCode value="" />
        </CenterText>
      </Modal>

      <TitleRow>
        <PageTitle>Welcome, Instructor {userName}</PageTitle>

        <TwoColumns>
          <Select
            style={{ width: '200px' }}
            label="Filter by Sponsor"
            {...instructorReportsConfig.sponsors}
            value={sponsors}
            onChange={e => {
              const lastSelection = e.length - 1;
              const all = e.filter(s => s === 'all');
              let sponsorSelected = [...e];
              if (all.length > 0) {
                if (e[lastSelection] === 'all') {
                  sponsorSelected = all;
                } else {
                  sponsorSelected = e.filter(s => s !== 'all');
                }
              }
              setSponsor([...sponsorSelected]);
            }}
            mode="multiple"
          />

          <Select
            options={[
              { id: 'all', label: 'All' },
              { id: 'monday', label: 'Monday' },
              { id: 'tuesday', label: 'Tuesday' },
              { id: 'wednesday', label: 'Wednesday' },
              { id: 'thursday', label: 'Thursday' },
              { id: 'friday', label: 'Friday' },
              { id: 'saturday', label: 'Saturday' },
              { id: 'sunday', label: 'Sunday' },
              { id: 'night_class', label: 'Night class' },
              { id: 'weekend_class', label: 'Weekend class' },
              { id: 'dayClass', label: 'Day Class' },
              { id: 'part_time', label: 'Part-Time Class' },
              { id: 'half_day_am', label: 'Half-day AM' },
              { id: 'half_day_pm', label: 'Half-day PM' }
            ]}
            mode="multiple"
            label="Filter by Day"
            value={classType}
            showArrow={false}
            style={{ width: '150px' }}
            placeholder="Select a day"
            onChange={e => {
              const lastSelection = e.length - 1;
              const all = e.filter(s => s === 'all' || s === 'dayClass');
              let classSelected = [...e];

              if (all.length > 0) {
                if (e[lastSelection] === 'all') {
                  classSelected = all;
                } else {
                  classSelected = e.filter(s => s !== 'all');
                }
              }
              PersistentRepo.set('day', classSelected.length === 0 ? ['all'] : [...classSelected]);
              setClassType(classSelected.length === 0 ? ['all'] : [...classSelected]);
            }}
          />

          <Select
            showSearch
            onChange={onFilterBranch}
            label="Filter by Branch"
            {...config.location}
            value={`allxallx${mainBranchId}`}
            showArrow={false}
            filterFn={item => item.type === 0}
            style={{ width: '250px' }}
          />

          <Select
            onChange={onFilterByLocation}
            value={locationFilter}
            options={locationFilterOptions}
            label="Filter by Type"
            showArrow={false}
            style={{ width: '140px' }}
          />

          <Select
            style={{ width: '150px' }}
            options={[
              { id: 'all', label: 'All' },
              { id: 'Group 1', label: 'Group 1' },
              { id: 'Group 2', label: 'Group 2' },
              { id: 'Group 3', label: 'Group 3' },
              { id: 'Group 4', label: 'Group 4' },
              { id: 'Group 5', label: 'Group 5' },
              { id: 'Group 6', label: 'Group 6' },
              { id: 'Group 7', label: 'Group 7' },
              { id: 'Group 8', label: 'Group 8' },
              { id: 'Group 9', label: 'Group 9' },
              { id: 'Group 10', label: 'Group 10' },
              { id: 'Group 11', label: 'Group 11' },
              { id: 'Group 12', label: 'Group 12' }
            ]}
            label="Filter by Groups"
            showArrow={false}
            value={selectedGroup}
            onChange={group => setGroup(group)}
          />

          <Select
            style={{ width: '220px' }}
            label="Student Status"
            options={[
              { id: 'Active', label: 'Active' },
              { id: 'Awaiting Yard Start', label: 'Awaiting Yard Start Date' },
              { id: 'Waiting for start date', label: 'Waiting for Start Date' },
              { id: 'Hold', label: 'Hold' },
              { id: 'Passed CDL Exam', label: 'Passed CDL Exam' }
            ]}
            value={studentStatus}
            onChange={e => {
              if (!e.length) {
                return;
              }
              const newStudentStatus = [...e];

              PersistentRepo.set('studentStatus', newStudentStatus);
              setStudentStatus(newStudentStatus);
            }}
            mode="multiple"
          />

          {hasSelectedLocation ? (
            buttons()
          ) : (
            <Tooltip title="Select a yard or a classroom">{buttons()}</Tooltip>
          )}
        </TwoColumns>
      </TitleRow>

      {!!location ? renderAttendance() : renderTablePlaceholder()}

      <Modal width={'70%'} visible={getShown('studentIntervention')} footer={[]}>
        <StudentIntervention />
      </Modal>
    </PageContainer>
  );
};
